import React, { Component } from 'react';
import { Col } from 'react-flexbox-grid';
import ReactSVG from 'react-svg';
import axios from 'axios';
import iziToast from 'izitoast';

import { PageGrid } from '../shared/CommonStyledComponents';
import { contactAPIEndpoint } from '../config';
import {
  ContactRow,
  FormColumn,
  FormRow,
  ContactInput,
  ContactTextArea,
  ContactButtonsContainer,
  ContactButtonContainer,
  ContactButton,
  ButtonLoadingImage,
  FlowerPotContainer,
  ErrorMessage,
  HiddenSubmitButton
} from './Contact/styles';
import { validateForm } from './Contact/helpers';
import NextPageLink from '../shared/NextPageLink';

import flowerPot from '../assets/images/flower-pot.svg';
import successIcon from '../assets/icons/success.svg';
import warningIcon from '../assets/icons/warning.svg';
import errorIcon from '../assets/icons/error.svg';
import loadingIcon from '../assets/icons/loading.svg';
import workWithUsSideLink from '../assets/images/sideLinks/work_with_us_side_link.svg';


window.submitForm = () => {
  const submitButton = document.getElementById('submit-form');
  submitButton.click();
};

const initialState = {
  name: '',
  nameValid: 'yetToValidate',
  email: '',
  emailValid: 'yetToValidate',
  content: '',
  contentValid: 'yetToValidate',
  loading: false
};

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;

    this.updateState = this.updateState.bind(this);
    this.sendMail = this.sendMail.bind(this);
  }

  sendMail(event) {
    event.preventDefault();
    const { name, email, content, nameValid, emailValid, contentValid } = this.state;

    this.setState({
      loading: true
    });

    const captchaToken = window.grecaptcha.getResponse();
    window.grecaptcha.reset();

    if (nameValid === 'valid' && emailValid === 'valid' && contentValid === 'valid') {
      axios.post(contactAPIEndpoint, {
        senderEmail: email,
        senderName: name,
        content,
        captchaToken
      })
      .then(() => {
        this.setState(initialState);

        iziToast.show({
          title: 'Success!',
          message: `We successfully sent your message. We will reply to you as soon as possible.
          Have a nice day!`,
          color: '#25AE88',
          image: successIcon,
          timeout: 8000
        });
      })
      .catch(() => {
        iziToast.show({
          title: 'Oops! Something went wrong!',
          message: `Sorry for the inconvenience! Something went wrong from our side.
            Please try again.`,
          color: '#EFCE4A',
          image: warningIcon,
          timeout: 8000
        });

        this.setState({
          loading: false
        });
      });
    } else {
      iziToast.show({
        title: 'Error!',
        message: 'Please make sure the form is error free (All green) before submitting!',
        color: '#D75A4A',
        image: errorIcon,
        timeout: 8000
      });

      this.setState({
        loading: false
      });
    }
  }

  updateState(key, value) {
    const newState = {};
    newState[key] = value;

    const validationOutput = validateForm(newState);
    newState[`${key}Valid`] = validationOutput[`${key}Valid`];

    this.setState(newState);
  }

  render() {
    const { name, email, content, nameValid, emailValid, contentValid, loading } = this.state;

    return (
      <PageGrid id="contact">
        <form>
          <ContactRow>
            <FormColumn xs={12} md={6}>
              <FormRow>
                <Col xs={12} md={6}>
                  <ContactInput
                    id="name"
                    type="text"
                    placeholder="Your Name"
                    onChange={(event) => { this.updateState('name', event.target.value); }}
                    value={name}
                    valid={nameValid}
                    autocomplete="off"
                  />
                  <ErrorMessage>{nameValid === 'invalid' && 'Name can\'t be blank!'}</ErrorMessage>
                </Col>
                <Col xs={12} md={6}>
                  <ContactInput
                    id="email"
                    type="text"
                    placeholder="Your Email"
                    onChange={(event) => { this.updateState('email', event.target.value); }}
                    value={email}
                    valid={emailValid}
                    autoComplete="off"
                  />
                  <ErrorMessage>{emailValid === 'invalid' && 'Invalid Email'}</ErrorMessage>
                </Col>
                <Col xs={12}>
                  <ContactTextArea
                    name="content"
                    id="content"
                    cols="30"
                    rows="10"
                    placeholder="How can we help you?"
                    onChange={(event) => { this.updateState('content', event.target.value); }}
                    value={content}
                    valid={contentValid}
                    data-gramm={false}
                  />
                  <ErrorMessage>
                    {contentValid === 'invalid' && `Please enter at least 50
                    charachters. Your current message is only ${content.length} charcahters long!`}
                  </ErrorMessage>
                </Col>
              </FormRow>

            </FormColumn>
            <Col xs={12} md={3}>
              <ContactButtonsContainer>
                <ContactButtonContainer className="first">
                  <ContactButton
                    type="submit"
                    className="g-recaptcha"
                    data-sitekey="6Ld86iYUAAAAABw_xKxsAaJa-Q2h5HSxXI_DTEF5"
                    data-callback="submitForm"
                    textVisible={!loading}
                  >
                    <ButtonLoadingImage src={loadingIcon} alt="Loading" visible={loading} />
                    <span className="button-text">Send</span>
                  </ContactButton>
                  <HiddenSubmitButton
                    onClick={this.sendMail}
                    id="submit-form"
                  >
                    Submit
                  </HiddenSubmitButton>
                </ContactButtonContainer>
                <ContactButtonContainer>
                  <ContactButton type="reset" textVisible>
                    <span className="button-text">Reset</span>
                  </ContactButton>
                </ContactButtonContainer>
              </ContactButtonsContainer>
            </Col>
            <Col xs={12} md={3}>
              <FlowerPotContainer>
                <ReactSVG
                  path={flowerPot}
                />
              </FlowerPotContainer>
            </Col>
          </ContactRow>
        </form>
        <NextPageLink
          color="FF9D00"
          image={workWithUsSideLink}
          text="WORK WITH US"
          currentPage="contact"
          nextPage="workwithus"
          translateVal={600}
        />
      </PageGrid>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js